<template>
    <CompassModal
        v-model:visible="showModal"
        size="small"
        :title="
            $t.__(
                'activities.listing.massActions.ActivitiesListingMassDelete.delete_activities_title',
            )
        "
        :primaryAction="{
            type: 'primary-destructive',
            label: $t.__('common.actions.confirm_and_delete'),
            action: () => confirmMassDelete(),
            loading: isSubmitting,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                action: () => {
                    $emit('close');
                },
            },
        ]"
        @closed="$emit('close')"
    >
        <span class="typographies-paragraph-medium-regular">
            {{ textContent }}
        </span>
    </CompassModal>
</template>
<script>
import { massDelete } from 'api/activities/activitiesMassActionsService';

export default {
    props: {
        selectedActivities: {
            type: Array,
            default: () => [],
        },
        onError: {
            type: Function,
            default: () => {},
        },
        onSuccess: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showModal: true,
            isSubmitting: false,
        };
    },
    computed: {
        textContent() {
            return this.$l10n.n__(
                'Êtes-vous sûr de vouloir supprimer cette activité ?',
                'Êtes-vous sûr de vouloir supprimer ces %d activités ?',
                this.selectedActivities.length,
                this.selectedActivities.length,
            );
        },
    },
    methods: {
        async confirmMassDelete() {
            try {
                this.isSubmitting = true;
                await massDelete(this.selectedActivities);
                this.$emit('close');
                this.onSuccess();
            } catch (error) {
                this.onError(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
